import ObjectID from "bson-objectid";

export class DbHelper {
  static createId(): string {
    const newObjectId = new ObjectID().toHexString();
    return newObjectId;
  }

  static createUniqueId(isUniqueCallback: (id: string) => boolean): string {
    let id = DbHelper.createId();
    while (!isUniqueCallback(id)) id = DbHelper.createId();
    return id;
  }


  static removeId<T extends { _id: any }>(item: T): Omit<T, "_id">;
  static removeId<T extends {}>(item: T): T;
  static removeId<T extends { _id: any }>(item: T): Omit<T, "_id"> {
    const { _id, ...ret } = item;
    return ret;
  }
}

export type DbDocHelper<T extends {}> = Omit<T, "_id"> & { _id?: object };
